import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import ThemeInfo from '../pages/theme-info'
import SiteInfo from '../pages/site-info'
import Dashboard from "../pages/dashboard";
import NotFound from "../pages/404";

function Nav() {
    return (
        <Router>
            <Routes>
                <Route path="/" exact element={<Dashboard />}/>
                <Route path="/theme-info/:id" element={<ThemeInfo />} />
                <Route path="/site-info/:id" element={<SiteInfo />} />
                <Route component={NotFound}/>
            </Routes>
        </Router>
    )
}

export default Nav;